<!-- eslint-disable vue/no-v-html -->
<template>
  <section>
    <b-row>
      <!-- Left content -->
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <!-- Número de boletin y fecha -->
        <div class="text-center my-2">
          <b-skeleton-wrapper :loading="loader">
            <template #loading>
              <b-card-body>
                <b-skeleton
                  type="button"
                  width="100%"
                />
              </b-card-body>
            </template>
          </b-skeleton-wrapper>

          <h4 v-if="!loader">
            <span v-if="!isEmptyObject(boletin)">
              Nueva época No. {{ numero }} | {{ boletin.fecha }}
            </span>
            <span v-else>
              Información no encontrada
            </span>
          </h4>
        </div>

        <!-- Cintillo -->
        <b-card
          bg-variant="dark"
          text-variant="white"
          no-body
        >
          <b-skeleton-wrapper :loading="loader">
            <template #loading>
              <b-card-body>
                <b-skeleton
                  v-for="item in 8"
                  :key="item"
                  :width="`${Math.random() * (100 - 10) + 10}%`"
                  class="mb-50"
                />
              </b-card-body>
            </template>
          </b-skeleton-wrapper>

          <b-card-body
            v-if="!loader && !isEmptyObject(boletin)"
            style="line-height: normal; font-size: small; text-align: justify !important;"
          >
            {{ boletin.cintillo }}
          </b-card-body>
        </b-card>

        <!-- Descripción de Boletín -->
        <b-card
          bg-variant="secondary"
          text-variant="white"
          no-body
        >
          <b-skeleton-wrapper :loading="loader">
            <template #loading>
              <b-card-body>
                <b-skeleton
                  v-for="item in 8"
                  :key="item"
                  :width="`${Math.random() * (100 - 10) + 10}%`"
                  class="mb-50"
                />
              </b-card-body>
            </template>
          </b-skeleton-wrapper>

          <b-card-body
            v-if="!loader && !isEmptyObject(boletin)"
            style="line-height: normal; font-size: small; text-align: justify !important;"
          >
            El Boletín Financiero es una difusión periódica vía red de cómputo dirigida a servidores públicos hacendarios, cuyo contenido son noticias de interés, acuerdos, reformas y/o decretos publicados en el Diario Oficial de la Federación, y en algunos casos, artículos, notas de interés, fichas técnicas, etcétera, escritos por personal que labora en INDETEC, que competen a la Hacienda Pública, el cual tiene como objetivo mantener informados a los servidores públicos hacendarios para contribuir a un mejor desempeño de la hacienda pública municipal, estatal y federal.
          </b-card-body>
        </b-card>

        <!-- Consejo y Editorial -->
        <b-card
          no-body
          bg-variant="primary"
        >
          <b-skeleton-wrapper :loading="loader">
            <template #loading>
              <b-card-body>
                <b-row>
                  <b-col
                    lg="6"
                    md="12"
                    sm="12"
                    class="mb-2"
                  >
                    <b-skeleton
                      v-for="item in 8"
                      :key="item"
                      :width="`${Math.random() * (100 - 10) + 10}%`"
                      class="mb-50"
                    />
                  </b-col>
                  <b-col
                    lg="6"
                    md="12"
                    sm="12"
                    class="mb-2"
                  >
                    <b-skeleton
                      v-for="item in 8"
                      :key="item"
                      :width="`${Math.random() * (100 - 10) + 10}%`"
                      class="mb-50"
                    />
                  </b-col>
                </b-row>
              </b-card-body>
            </template>
          </b-skeleton-wrapper>

          <b-card-body v-if="!loader && !isEmptyObject(boletin)">
            <b-row v-if="boletin">
              <b-col
                lg="6"
                md="12"
                sm="12"
                class="mb-2"
              >
                <div class="text-center mb-1">
                  <h4 :class="`text-${isDark ? 'white' : 'dark'}`">
                    Consejo técnico editorial
                  </h4>
                </div>

                <div
                  v-for="consejo in boletin.consejoEditorial"
                  :key="consejo.id"
                  class="mb-75"
                  :class="`text-${isDark ? 'white' : 'dark'}`"
                >
                  <p
                    class="m-0"
                    :class="{ 'mt-1': consejo.id == 6 }"
                  >
                    <b>{{ consejo.nombre }}</b>
                  </p>
                  <!-- <hr class="m-0"> -->
                  <p
                    v-for="miembro in consejo.miembros"
                    :key="miembro.id"
                    class="m-0"
                  >
                    {{ miembro.nombre }}
                  </p>
                </div>
              </b-col>
              <b-col
                lg="6"
                md="12"
                sm="12"
                class="mb-2"
              >
                <div class="text-center mb-1">
                  <h4 :class="`text-${isDark ? 'white' : 'dark'}`">
                    Editorial
                  </h4>
                </div>

                <div
                  :class="`text-${isDark ? 'white' : 'dark'}`"
                  style="text-align: justify !important;"
                  v-html="boletin.editorial"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Right content -->
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <!-- Pagination -->
        <div class="text-center my-2">
          <b-skeleton-wrapper :loading="loader || loaderFiles">
            <template #loading>
              <b-card-body>
                <b-skeleton
                  type="button"
                  width="100%"
                />
              </b-card-body>
            </template>
          </b-skeleton-wrapper>

          <b-pagination
            v-if="!loader && !loaderFiles"
            v-model="paginationNum"
            :total-rows="maxPaginationNum"
            :per-page="1"
            first-number
            last-number
            hide-goto-end-buttons
            align="center"
          />
        </div>

        <!-- Files -->
        <div v-if="!isEmptyObject(boletin)">
          <b-skeleton-wrapper :loading="loader || loaderFiles">
            <template #loading>
              <b-card
                v-for="item in 4"
                :key="item"
                class="mb-1"
              >
                <b-skeleton
                  v-for="skltn in 8"
                  :key="skltn"
                  :width="`${Math.random() * (100 - 10) + 10}%`"
                  class="mb-25"
                />
              </b-card>
            </template>
          </b-skeleton-wrapper>

          <div v-if="!loader && !loaderFiles">
            <card-file
              v-for="f_by_s in files"
              :key="f_by_s.id"
              :data="f_by_s"
            />
          </div>
        </div>
        <div
          v-else
          class="text-center"
        >
          <span>Información no encontrada</span>
        </div>

        <!-- Historico Boletín e-Financiero -->
        <div class="text-center">
          <router-link
            class="text-dark"
            to="/history"
          >
            Click para ver los <b>archivos históricos (Ediciones anteriores)</b>
          </router-link>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
/* eslint-disable import/no-cycle */
import store from '@/store'
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BSkeletonWrapper,
  BSkeleton,
  BPagination,
} from 'bootstrap-vue'
import useAppConfig from '@core/app-config/useAppConfig'
import Ripple from 'vue-ripple-directive'
import {
  ref,
  onMounted,
  computed,
  watch,
} from '@vue/composition-api'
import { useRouter, isEmptyObject } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CardFile from './CardFile.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BSkeletonWrapper,
    BSkeleton,
    BPagination,

    CardFile,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { skin } = useAppConfig()
    const { route } = useRouter()
    const toast = useToast()
    const loader = ref(false)
    const loaderFiles = ref(false)
    const boletin = ref({})
    const files = ref([])
    const numero = ref(null)
    const paginationNum = ref(null)
    const maxPaginationNum = ref(null)
    const isDark = computed(() => skin.value === 'dark')

    // * Archivos de boletin
    const loadFiles = () => {
      loaderFiles.value = true

      store.dispatch('ediciones/detailItem', { all: numero.value }).then(response => {
        const { status, data } = response
        const { error, result } = data

        if (status !== 200 || error) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Información de solicitud de archivos',
              text: result,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 8000 })
        } else {
          files.value = result
        }

        loaderFiles.value = false
      }).catch(err => {
        loaderFiles.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Vuelva a intentarlo más tarde',
            text: err,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      })
    }

    // * Detalles del boletin
    const loadBoletin = () => {
      loader.value = true

      store.dispatch('ediciones/detailItem', numero.value ? { bf: numero.value } : { first: 0 }).then(response => {
        const { status, data } = response
        const { error, result } = data

        if (status !== 200 || error) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Información de solicitud de boletín',
              text: result,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 8000 })
        } else {
          boletin.value = result
          numero.value = result.numero
          paginationNum.value = (numero.value && parseInt(numero.value, 10) && /[\^0-9]/.test(numero.value)) ? numero.value : undefined
          maxPaginationNum.value = (result && result.maxBoletin) ? parseInt(result.maxBoletin, 10) : numero.value
          loadFiles()
        }

        loader.value = false
      }).catch(err => {
        loader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Vuelva a intentarlo más tarde',
            text: err,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      })
    }

    onMounted(() => {
      numero.value = (route.value.params.x && parseInt(route.value.params.x, 10) && /[\^0-9]/.test(route.value.params.x)) ? route.value.params.x : undefined
      loadBoletin()
    })

    watch(paginationNum, val => {
      if (val !== numero.value) {
        numero.value = (paginationNum.value && parseInt(paginationNum.value, 10) && /[\^0-9]/.test(paginationNum.value)) ? paginationNum.value : undefined
        loadBoletin()
      }
    })

    return {
      boletin,
      loader,
      loaderFiles,
      isDark,
      files,
      paginationNum,
      maxPaginationNum,
      isEmptyObject,
      numero,
    }
  },
}
</script>
